"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _types = _interopRequireDefault(require("../types"));

var scarlet = '#d0021b';
var lots = ['#6dcc3d', '#00b075'];
var medium = ['#ffd500', '#f49511'];
var few = ['#cc0000', '#f35c10'];
var colors = {
  few: few,
  medium: medium,
  lots: lots
};

var getColorStops = function getColorStops(places) {
  var stops = [];
  var quantity = places.filter(function (i) {
    return i !== _types["default"][3];
  });

  if (quantity.length === 2) {
    if (quantity[0] !== quantity[1]) {
      stops.push(colors[quantity[0]][0], colors[quantity[1]][0]);

      if (places[0] === _types["default"][0] && places[1] === _types["default"][1]) {
        stops.unshift(scarlet);
      }
    } else {
      stops.push.apply(stops, (0, _toConsumableArray2["default"])(colors[quantity[0]]));
    }
  } else if (quantity.length === 1) {
    stops.push.apply(stops, (0, _toConsumableArray2["default"])(colors[quantity[0]]));
  }

  return stops.reduce(function (acc, item, index, array) {
    acc.push({
      offset: index / (array.length - 1),
      stopColor: item
    });
    return acc;
  }, []);
};

var _default = getColorStops;
exports["default"] = _default;